import { BRAND_NAME } from '../lib/brand';

type Tone = 'dark' | 'light';

interface BrandMarkProps {
  tone?: Tone;
  showWordmark?: boolean;
  size?: number;
  className?: string;
}

export function BrandGlyph({ tone = 'dark', size = 28 }: { tone?: Tone; size?: number }) {
  const ink = tone === 'dark' ? '#1F1B16' : '#FDFBF7';
  const accent = '#1F7E68';
  const stroke = Math.max(2.2, size * 0.085);

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M9.4 8.6 Q 12.8 13.1 18.6 18.1 Q 13.1 22.4 8.2 27.1"
        stroke={ink}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.4 27.7 Q 25.2 27.1 28.6 27.4"
        stroke={accent}
        strokeWidth={stroke}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function BrandMark({
  tone = 'dark',
  showWordmark = true,
  size = 28,
  className = '',
}: BrandMarkProps) {
  const ink = tone === 'dark' ? 'text-ink-900' : 'text-warm-50';

  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <BrandGlyph tone={tone} size={size} />
      {showWordmark && (
        <span
          className={`font-display font-medium ${ink} tracking-tight leading-none`}
          style={{ fontSize: Math.round(size * 0.78), letterSpacing: '-0.018em' }}
        >
          {BRAND_NAME.toLowerCase()}
        </span>
      )}
    </span>
  );
}
